import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
  // 通过code获取微信用户OpenId和accessToken
  getOpenId(params) {
    return Axios({
      url: requestPrefix.centerUrl + '/sys/wx/oauth/getOpenid/' + params,
      method: 'get'
    })
  },

  // 通过code获取微信用户OpenId和accessToken
  weixinLogin(params) {
    return Axios({
      url: requestPrefix.centerUrl + '/users/weixinLogin',
      method: 'get',
      params: params
    })
  },

  weixinLogout() {
    return Axios({
      url: requestPrefix.centerUrl + '/users/weixinLogout',
      method: 'get'
    })
  },

  getWeiXinRedirectUrl() {
    return Axios({
      url: requestPrefix.centerUrl + '/users/getWeiXinRedirectUrl',
      method: 'get'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/authorization/index.js